<div
  class="list-view-wrapper"
  id="home-list-view-aside"
  [ngClass]="{ mobile: isMobile }"
>
  <div class="content">
    <app-home-notice></app-home-notice>
    <app-home-header
      [disabled]="loading"
      [isLoggedIn]="isLoggedIn"
    ></app-home-header>

    <ng-container *ngIf="isMobile">
      <div class="mb-5 max-w-xs mx-auto" *ngIf="loading && !!(count$ | async)">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </ng-container>

    <div *ngIf="loading && !properties?.length" class="pt-4 pb-20">
      <app-shared-loading
        position="left"
        text="Loading properties..."
      ></app-shared-loading>
    </div>

    <div *ngIf="hasErrors || (!loading && !properties?.length)" class="p-5">
      <app-shared-no-results
        message="Try adjusting your search or filter to find what you're looking for."
      ></app-shared-no-results>
    </div>

    <div
      *ngIf="isMobile"
      class="grid gap-4 xl:gap-6 grid-cols-1 sm:grid-cols-2"
    >
      <app-shared-property-list
        *ngFor="let property of showingProperties; trackBy: trackByFn"
        [shareModalOpen]="!!shareModalProperty"
        [property]="property"
        [isLoggedIn]="true"
        (openShareModal)="this.shareModalProperty = property"
      ></app-shared-property-list>
    </div>

    <div
      *ngIf="!isMobile"
      class="grid gap-4 xl:gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-1 2xl:grid-cols-2"
    >
      <app-shared-property-list
        *ngFor="let property of showingProperties; trackBy: trackByFn"
        [shareModalOpen]="!!shareModalProperty"
        [property]="property"
        [isLoggedIn]="true"
        (openShareModal)="this.shareModalProperty = property"
      ></app-shared-property-list>
    </div>

    <div class="mt-5 text-center">
      <div *ngIf="!showingLastProperty" class="max-w-[160px] mx-auto">
        <app-shared-button (click)="handleShowMore()">
          Show more
        </app-shared-button>
      </div>
      <div
        *ngIf="showingLastProperty && !loading && !!showingProperties?.length"
        class="text-gray-500"
      >
        <span>No more properties to show</span>
      </div>
    </div>

    <!-- <div *ngIf="!loading">
      <app-shared-paginator
        [pagination]="{
          limit: propertiesPerPage,
          count: (count$ | async) || 0
        }"
      ></app-shared-paginator>
    </div> -->
  </div>
  <app-shared-layout-footer></app-shared-layout-footer>
</div>

<app-property-share-modal
  *ngIf="!!shareModalProperty"
  [open]="!!shareModalProperty"
  (handleClose)="shareModalProperty = undefined"
  [property]="shareModalProperty"
></app-property-share-modal>
